<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 purchases-invoice-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_INVOICES.ADD_PURCHASES_INVOICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchases-invoice-form
              :loading="loading"
              :purchasesInvoiceData="purchasesInvoice"
              :formErrors="formErrors"
              @purchasesInvoiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesInvoice from "./defaultPurchasesInvoice";
import PurchasesInvoiceForm from "./partials/PurchasesInvoiceForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesInvoiceForm,
  },

  mixins: [alertLeave],

  data() {
    const purchasesInvoice = cloneDeep(defaultPurchasesInvoice);
    if (this.$currentUserIsLevelOrganization()) {
      purchasesInvoice.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      purchasesInvoice: purchasesInvoice,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List PurchasesInvoices" });
    },

    viewPurchasesInvoice(purchasesInvoice) {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesInvoice",
        params: { id: purchasesInvoice.id },
      });
    },

    async handleSubmit(purchasesInvoice) {
      this.loading = true;
      const purchasesInvoiceData = cloneDeep(purchasesInvoice);
      if (!purchasesInvoiceData.destinationWarehouse.id) {
        delete purchasesInvoiceData.destinationWarehouse;
      }
      try {
        await this.$store.dispatch(
          "purchasesInvoices/add",
          purchasesInvoiceData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_ADDED"),
        });
        const purchasesInvoice = await this.$store.getters[
          "purchasesInvoices/purchasesInvoice"
        ];
        this.viewPurchasesInvoice(purchasesInvoice);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
